// extracted by mini-css-extract-plugin
module.exports = {"valuesModal":"valuesRewriteModal_valuesModal__wH_Mf","valuesModalBody":"valuesRewriteModal_valuesModalBody__25N9j"};